module.exports = __webpack_public_path__ + "static/img/car.6615a6ed.png";